import React, { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import {
  Card,
  Form,
  Input,
  Button,
  message,
  Upload,
  Select,
  Col,
  Row,
  Tabs,
  Spin,
  Avatar,
  Typography,
  Cascader
} from 'antd'
import {
  UserOutlined,
  FileOutlined,
  ClockCircleOutlined,
  CalendarOutlined,
  CameraOutlined,
  DeleteOutlined,
  LeftOutlined
} from '@ant-design/icons'
import styled from 'styled-components'
import { PHOTO_URL } from '../utils/apiutils'
import EmployeeWorkHours from '../components/EmployeeWorkHours'
import EmployeeDaysOff from '../components/EmployeeDaysOff'
import EmployeePortfolio from '../components/EmployeePortfolio'
import AssignedServices from './AssignedServices'
import { categories } from '../utils/utils'
import { useLocation, useNavigate } from 'react-router-dom'
import useGoBack from '../hooks/useGoBack'
import cityData from '../utils/cityData'
import { Toast } from 'antd-mobile'
import api from '../utils/api'
import EmployeeExperience from '../components/EmplyeeExperience'

const { Title } = Typography

const Container = styled.div`
  max-width: 1200px;
  margin: auto;
  padding: 20px;
  @media (max-width: 820px) {
    padding: 0px;
  }
`

const StyledCard = styled(Card)`
  margin-bottom: 24px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  @media (max-width: 820px) {
    box-shadow: none;
    border: none;
    padding: 0px;

    .ant-card-body {
      padding: 5px 10px;
    }
  }
`

const MenuCard = styled.div`
  .ant-tabs-nav {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .ant-tabs-nav-list {
    display: flex;
    flex-wrap: nowrap;
  }
  .ant-tabs-tab {
    flex: none;
  }
  @media (max-width: 820px) {
    .ant-tabs-nav-list {
      flex-direction: row;
    }
    .ant-tabs-tab {
      /* margin-right: 5px; */
    }
    .ant-tabs-tab-btn {
      padding: 5px 0;
    }
  }
`

const ContentCard = styled(StyledCard)`
  overflow: auto;

  @media (max-width: 820px) {
    padding-bottom: 80px;
  }
`

const AvatarUpload = styled.div`
  position: relative;
  display: inline-block;
  margin-bottom: 24px;
`

const AvatarOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`

const DeleteButton = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
  z-index: 1;
`

const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
`

const StyledTag = styled.span`
  display: inline-block;
  background-color: white;
  border: 1px solid #d5728a;
  color: #d5728a;
  border-radius: 16px;
  padding: 4px 12px;
  margin-right: 8px;
  margin-bottom: 8px;

  .close-icon {
    margin-left: 8px;
    color: #d5728a;
    cursor: pointer;

    &:hover {
      color: #ff4d4f;
    }
  }
`

const StyledCascader = styled(Cascader)`
  width: 100%;
`
const ButtonGroup = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;

  @media (max-width: 820px) {
    display: none;
  }
`
const StyledButton = styled(Button)`
  width: 100%;
  height: 50px;
  font-size: 16px;
`

const FixedButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  z-index: 1000;

  @media (min-width: 821px) {
    display: none;
  }
`

const EmployeeDetail = () => {
  const { businessId, employeeId } = useParams()
  const [employee, setEmployee] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [form] = Form.useForm()
  const [tags, setTags] = useState([])
  const [fileList, setFileList] = useState([])
  const [selectedMenu, setSelectedMenu] = useState('1')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const goBack = useGoBack('/employees')
  const [options, setOptions] = useState([])
  const [avatarPreview, setAvatarPreview] = useState(null)

  useEffect(() => {
    if (cityData && cityData.districts && Array.isArray(cityData.districts)) {
      const formattedOptions = cityData.districts.map((district) => ({
        value: district.name,
        label: district.name,
        children:
          district.areas && Array.isArray(district.areas)
            ? district.areas.map((area) => ({
                value: area,
                label: area
              }))
            : []
      }))
      setOptions(formattedOptions)
    } else {
      console.error('cityData 結構不正確:', cityData)
      message.error('加載地區數據失敗')
    }
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const tabFromUrl = params.get('tab')
    if (tabFromUrl) {
      setSelectedMenu(tabFromUrl)
    }
  }, [location.search])

  const fetchEmployee = useCallback(async () => {
    try {
      const response = await api.get(
        `/api/employees/${businessId}/${employeeId}`
      )
      setEmployee(response.data)
      form.setFieldsValue(response.data)
      setTags(response.data.tags || [])
      if (response.data.avatar) {
        const avatarUrl = `${PHOTO_URL}${response.data.avatar}`
        setAvatarPreview(avatarUrl)
        setFileList([
          {
            uid: '-1',
            url: avatarUrl,
            name: 'avatar'
          }
        ])
      }
      setIsLoading(false)
    } catch (error) {
      console.error('Error fetching employee:', error)
      message.error('Failed to fetch employee details.')
      setIsLoading(false)
    }
  }, [businessId, employeeId, form])

  useEffect(() => {
    fetchEmployee()
  }, [fetchEmployee])

  const beforeUpload = (file) => {
    const isAllowedType =
      /\.(jpeg|jpg|png|gif|mp4|mov|quicktime|webp|heic|heif|bmp)$/i.test(
        file.name
      )
    const isLt5M = file.size / 1024 / 1024 < 5

    if (!isAllowedType) {
      message.error(
        '不支持的文件格式！請上傳 JPEG, JPG, PNG, GIF, MP4, MOV, QuickTime, WebP, HEIC, HEIF 或 BMP 格式的文件。'
      )
    }
    if (!isLt5M) {
      message.error('文件必須小於 5MB！')
    }

    return isAllowedType && isLt5M
  }

  const handleFileChange = ({ fileList: newFileList }) => {
    if (newFileList.length > 0 && newFileList[0].originFileObj) {
      const file = newFileList[0].originFileObj
      if (beforeUpload(file)) {
        const reader = new FileReader()
        reader.onload = (e) => {
          setAvatarPreview(e.target.result)
        }
        reader.readAsDataURL(file)
        setFileList(newFileList.slice(0, 1)) // 只保留第一张图片
      }
    } else {
      setAvatarPreview(null)
      setFileList([])
      form.setFieldsValue({ avatar: undefined })
    }
  }

  const handleDeleteAvatar = () => {
    setAvatarPreview(null)
    setFileList([])
    form.setFieldsValue({ avatar: undefined })
    console.log('delete avatar', form.getFieldValue('avatar'))
    console.log('delete avatar filelist', fileList)
  }

  const handleFinish = async (values) => {
    setIsSubmitting(true)
    try {
      values.tags = tags
      values.phone = values.phone || ''
      values.bio = values.bio || ''
      values.area = Array.isArray(values.area) ? values.area : []
      values.yearsOfExperience = values.yearsOfExperience
        ? values.yearsOfExperience.toString()
        : ''

      const formData = new FormData()
      Object.keys(values).forEach((key) => {
        if (key === 'tags' || key === 'skillsType' || key === 'area') {
          formData.append(key, JSON.stringify(values[key]))
        } else {
          formData.append(key, values[key])
        }
      })
      if (fileList.length > 0 && fileList[0].originFileObj) {
        formData.append('avatar', fileList[0].originFileObj)
      }
      const response = await api.put(
        `/api/employees/${businessId}/${employeeId}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )

      // 假设服务器返回更新后的员工信息，包括新的头像URL
      if (response.data && response.data.avatar) {
        setAvatarPreview(`${PHOTO_URL}${response.data.avatar}`)
      }

      Toast.show({
        content: '員工詳細信息新成功。',
        position: 'top'
      })
      fetchEmployee()
    } catch (error) {
      console.error('更新員工時出錯：', error)
      Toast.show({
        content: '更新員工詳細信息失敗。',
        position: 'top'
      })
    } finally {
      setIsSubmitting(false)
    }
  }
  const handleTabChange = (newTab) => {
    setSelectedMenu(newTab)
    navigate(`?tab=${newTab}`, { replace: true }) // 更新URL中的tab參數
  }

  const handleTagAdd = (e) => {
    e.preventDefault()
    const newTag = form.getFieldValue('newTag')
    if (newTag && tags.length < 3 && !tags.includes(newTag)) {
      setTags([...tags, newTag])
      form.resetFields(['newTag'])
    } else if (tags.length >= 3) {
      message.error('最多只能添加3個標籤。')
    } else if (tags.includes(newTag)) {
      message.error('該標籤已存在。')
    }
  }

  const handleTagRemove = (removedTag) => {
    setTags(tags.filter((tag) => tag !== removedTag))
  }

  const handleAreaChange = (value) => {
    if (value && value.length >= 2) {
      form.setFieldsValue({
        'address.county': value[0],
        'address.district': value[1],
        area: value // 直接设置 area 为选择的值数组
      })
    }
  }

  const handleGoBack = () => {
    goBack() // 返回上一頁；直接開啟這頁時退回員工列表
  }

  const renderContent = () => {
    switch (selectedMenu) {
      case '1':
        return (
          <Form form={form} layout='vertical' onFinish={handleFinish}>
            <Row gutter={24} align='middle' justify='center'>
              <Col xs={24} sm={24} md={8} lg={6}>
                <AvatarUpload data-tour='employee-avatar'>
                  <Avatar
                    size={150}
                    icon={<UserOutlined />}
                    src={avatarPreview}
                  />
                  {avatarPreview && (
                    <DeleteButton onClick={handleDeleteAvatar}>
                      <DeleteOutlined />
                    </DeleteButton>
                  )}
                  <AvatarOverlay>
                    <Upload
                      accept='image/*'
                      showUploadList={false}
                      beforeUpload={() => false}
                      onChange={handleFileChange}
                      fileList={fileList}
                    >
                      <CameraOutlined style={{ fontSize: 24, color: '#fff' }} />
                    </Upload>
                  </AvatarOverlay>
                </AvatarUpload>
                <div
                  style={{
                    marginTop: '10px',
                    marginBottom: '20px',
                    color: '#888'
                  }}
                >
                  不支持 TIFF 格式
                  <br />
                  最多上傳 1 張圖片，大小不超過 5MB
                </div>
              </Col>
              <Col xs={24} sm={24} md={16} lg={18}>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name='name'
                      label='員工姓名'
                      rules={[{ required: true, message: '請輸入員工姓名' }]}
                    >
                      <Input data-tour='employee-name' />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name='email'
                      label='電子信箱'
                      rules={[{ required: true, message: '請輸入電子信箱' }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item name='username' label='帳號'>
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name='phone' label='電話'>
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item name='yearsOfExperience' label='工作年資'>
                      <Select
                        options={[
                          { value: '0', label: '1年以下' },
                          ...Array.from({ length: 19 }, (_, i) => ({
                            value: (i + 1).toString(),
                            label: `${i + 1}年`
                          })),
                          { value: '20', label: '20年以上' }
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name='skillsType'
                      label='專長項目'
                      rules={[{ required: true, message: '請選擇專長項目' }]}
                    >
                      <Select
                        mode='multiple'
                        options={categories
                          .filter((category) => category.type !== 'all')
                          .map((category) => ({
                            value: category.type,
                            label: category.name
                          }))}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name='employeeType'
                      label='員工類型'
                      rules={[{ required: true, message: '請選擇員工類型' }]}
                    >
                      <Select
                        options={[
                          { value: '一般員工', label: '一般員工' },
                          { value: '設計師', label: '設計師' },
                          { value: '美甲師', label: '美甲師' },
                          { value: '美睫師', label: '美睫師' },
                          { value: '美容師', label: '美容師' },
                          { value: '美體師', label: '美體師' },
                          { value: '美妝師', label: '美妝師' },
                          { value: '醫師', label: '醫師' }
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name='area' label='地區'>
                      <StyledCascader
                        options={options}
                        onChange={handleAreaChange}
                        placeholder='請選擇縣市和區域'
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item name='bio' label='個人簡介'>
                      <Input.TextArea rows={4} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item label='特色標籤'>
                      <TagContainer>
                        {tags.map((tag) => (
                          <StyledTag key={tag}>
                            {tag}
                            <span
                              className='close-icon'
                              onClick={() => handleTagRemove(tag)}
                            >
                              ×
                            </span>
                          </StyledTag>
                        ))}
                      </TagContainer>
                      <Form.Item name='newTag'>
                        <Input
                          placeholder='新增標籤'
                          onPressEnter={handleTagAdd}
                          style={{ width: '200px' }}
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Form.Item>
              <ButtonGroup>
                <StyledButton
                  type='primary'
                  htmlType='submit'
                  disabled={isSubmitting}
                >
                  {isSubmitting ? '保存中...' : '保存'}
                </StyledButton>
              </ButtonGroup>
            </Form.Item>

            <FixedButtonContainer>
              <StyledButton
                type='primary'
                onClick={() => form.submit()}
                disabled={isSubmitting}
                block
              >
                {isSubmitting ? '保存中...' : '保存'}
              </StyledButton>
            </FixedButtonContainer>
          </Form>
        )
      case '2':
        return (
          <AssignedServices
            employeeId={employeeId}
            businessId={businessId}
          />
        )
      case '3':
        return <EmployeeWorkHours employeeId={employeeId} />
      case '4':
        return <EmployeeDaysOff employeeId={employeeId} />
      case '5':
        return (
          <EmployeePortfolio employeeId={employeeId} businessId={businessId} />
        )
      case '6':
        return (
          <EmployeeExperience employeeId={employeeId} businessId={businessId} />
        )
      default:
        return null
    }
  }

  const renderTabs = () => {
    const items = [
      {
        key: '1',
        label: (
          <span>
            <UserOutlined style={{ marginRight: 5 }} />
            <span className='tab-text'>員工資訊</span>
          </span>
        )
      },
      {
        key: '2',
        label: (
          <span>
            <FileOutlined style={{ marginRight: 5 }} />
            <span className='tab-text'>服務列表</span>
          </span>
        )
      },
      {
        key: '3',
        label: (
          <span data-tour='employee-work-hours-tab'>
            <ClockCircleOutlined style={{ marginRight: 5 }} />
            <span className='tab-text'>工作時間</span>
          </span>
        )
      },
      {
        key: '4',
        label: (
          <span data-tour='employee-days-off-tab'>
            <CalendarOutlined style={{ marginRight: 5 }} />
            <span className='tab-text'>休假</span>
          </span>
        )
      },
      {
        key: '5',
        label: (
          <span data-tour='employee-portfolio-tab'>
            <CalendarOutlined style={{ marginRight: 5 }} />
            <span className='tab-text'>作品集</span>
          </span>
        )
      },
      {
        key: '6',
        label: (
          <span data-tour='employee-experience-tab'>
            <UserOutlined style={{ marginRight: 5 }} />
            <span className='tab-text'>個人經歷</span>
          </span>
        )
      }
    ]

    return (
      <Tabs
        activeKey={selectedMenu}
        onChange={handleTabChange}
        tabPosition='top'
        type='card'
        items={items}
      />
    )
  }

  return (
    <Container data-tour='employee-detail'>
      <Row align='middle' style={{ marginBottom: 24, marginTop: 5 }}>
        <Col>
          <Button
            icon={<LeftOutlined />}
            onClick={handleGoBack}
            style={{ marginRight: 16, border: 'none' }}
          >
            返回
          </Button>
        </Col>
        <Col>
          <Title level={4} style={{ margin: 0 }}>
            {employee ? employee.name : ''} 詳細資料
          </Title>
        </Col>
      </Row>
      <MenuCard>{renderTabs()}</MenuCard>
      <ContentCard>
        {isLoading ? <Spin style={{ margin: '50px 50%' }} /> : renderContent()}
      </ContentCard>
    </Container>
  )
}

export default EmployeeDetail
